// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// --- Quick cart / Clerk.io: keep data-products in sync with live cart (AJAX) and re-render ---
function clerkQuickCartSpan() {
    return document.getElementById('quick-cart-vertical') || document.querySelector('.clerk-sd[data-template="@quick-cart-vertical"]');
}

/** Repeat product_id per unit (line quantity), so qty 2 → two ids for Clerk. */
function clerkProductIdsFromCart(cart) {
    if (!cart || !cart.items || !cart.items.length) return [];
    var ids = [];
    cart.items.forEach(function (line) {
        var q = Math.max(1, Math.min(99, parseInt(line.quantity, 10) || 1));
        var pid = line.product_id;
        for (var i = 0; i < q; i++) ids.push(pid);
    });
    return ids;
}

function syncQuickCartClerkDataProducts(cart) {
    var span = clerkQuickCartSpan();
    if (!span) return;
    var ids = clerkProductIdsFromCart(cart);
    span.setAttribute('data-products', ids.length ? '[' + ids.join(',') + ']' : '[]');
}

function runQuickCartClerkContent() {
    if (typeof Clerk !== 'function') return;
    var span = clerkQuickCartSpan();
    if (!span) return;
    try {
        Clerk('content', '#quick-cart-vertical');
    } catch (e) {
        try {
            Clerk('content', '.clerk-sd[data-template="@quick-cart-vertical"]');
        } catch (e2) {
            console.warn('[Clerk] quick cart controlled render failed', e2);
        }
    }
}

/** After theme swaps DOM, span may appear late — sync data-products then Clerk once it exists. */
function scheduleQuickCartClerkRefresh(cart) {
    var hasItems = cart && cart.items && cart.items.length > 0;
    if (!hasItems) {
        var spanGone = clerkQuickCartSpan();
        if (spanGone) spanGone.setAttribute('data-products', '[]');
        return;
    }
    var maxAttempts = 12;
    var delayMs = 50;
    var attempt = 0;

    function tick() {
        var span = clerkQuickCartSpan();
        if (span) {
            syncQuickCartClerkDataProducts(cart);
            runQuickCartClerkContent();
            return;
        }
        if (++attempt < maxAttempts) setTimeout(tick, delayMs);
    }

    requestAnimationFrame(tick);
}

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.

/**
 * Shopper id association
 * BOX5x2	    PAPER BOX (5X5X2)		                BAGS	PAPER BAG SMALL ( 13X16X7) (300 X BOX)
 * BOX6x2	    PAPER BOX (6X6X2) (200 X BOX)		    BAGS	PAPER BAG SMALL ( 13X16X7) (300 X BOX)
 * BOX7x4	    PAPER BOX (7X7X4) (250 X BOX)		    BAGS	PAPER BAG SMALL ( 13X16X7) (300 X BOX)
 * BOX10x3,5	PAPER BOX (10X10X3,5) (200 X BOX)		BAGS	PAPER BAG SMALL ( 13X16X7) (300 X BOX)
 * BOX10x7	    PAPER BOX (10X10X7) (100 X BOX)		    BAGM	PAPER BAG MEDIUM (18X22X8) (300X BOX)
 * BOX13x3,5	PAPER BOX (13X13X3,5) (160 X BOX)		BAGM	PAPER BAG MEDIUM (18X22X8) (300X BOX)
 * BOX16x3,5	PAPER BOX (16X16X3,5) (50 X BOX)		BAGM	PAPER BAG MEDIUM (18X22X8) (300X BOX)
 *
 * id: 10312955068682 - variant_id: 52145234280714
 * id: 10312955134218 - variant_id: 52145234411786
 * id: 10312955199754 - variant_id: 52145234510090
 * id: 10312954872074 - variant_id: 52145233756426
 * id: 10312954904842 - variant_id: 52145233789194
 * id: 10312954970378 - variant_id: 52145233887498
 * id: 10312955003146 - variant_id: 52149004075274
 *
 *
 */
const paperBagSmall = 53066794664202;
const paperBagMedium = 53066794631434;
const currentShoppers = [
    paperBagSmall,
    paperBagMedium
];
const shopperAssociation = {
    52145234280714: paperBagSmall,
    52145234411786: paperBagSmall,
    52145234510090: paperBagSmall,
    52145233756426: paperBagSmall,
    52145233789194: paperBagMedium,
    52145233887498: paperBagMedium,
    52149004075274: paperBagMedium,
};
document.addEventListener('cart:item-added', async function (evt) {
    console.log('Item added to the cart');
    console.log(evt.detail.product);
    const giftQ = [...document.querySelectorAll('[data-gift-quantity]')];
    if (giftQ.length) {
        for (const _q of giftQ) {
            const q = parseInt(_q.querySelector('[data-quantity-input]')?.value);
            if (q > 0) {
                const box = _q.querySelector('[data-gift-box-id]');
                if (box) {
                    if (evt.detail.product === parseInt(box.value)) return;
                    let formData = {
                        'items': [{
                            'id': parseInt(box.value),
                            'quantity': q
                        }]
                    };
                    const shopperAccociated = !!shopperAssociation[box.value];
                    const opt = {
                        _product_id: evt.detail.product.product_id,
                        _variant_id: evt.detail.product.variant_id
                    };
                    if (shopperAccociated) {
                        opt._shopper_variant_id = shopperAssociation[box.value];
                    }
                    const { res } = await window.themeCart.addItemById(parseInt(box.value), q, opt);
                    // Associate shopper
                    if (shopperAccociated) {
                        const shopperRes = await window.themeCart.addItemById(shopperAssociation[box.value], q, {
                            _product_id: evt.detail.product.product_id,
                            _variant_id: evt.detail.product.variant_id,
                            _gift_box_variant_id: parseInt(box.value)
                        });
                    }
                    console.log('gift box with id:', box.value, 'added to cart with quantity', q);
                    document.dispatchEvent(new CustomEvent('confirmation-popup:open', {
                        product: res.items[0]
                    }));
                    // window.forceRefreshCart(res);
                }
            }
        }
    }
});


const updateAt = async (itemKey, q = 0) => {
    let updates = {
        'id': itemKey,
        'quantity': q,
    };
    const _res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
    });
    const json = await _res.json();
    window.forceRefreshCart(json)
};

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener('cart:updated', async function (evt) {
    console.log('Cart updated');
    console.log(evt.detail.cart);
    if (evt.detail.cart.total_price < 300) {
        // togliere gioiello omaggio da klaviyio
        for (let i = 0; i < evt.detail.cart.items.length; i++) {
            if (evt.detail.cart.items[i].id === 53492436173066) {
                await updateAt(evt.detail.cart.items[i].key);
                break;
            }
        }
    }
    const cart = evt.detail.cart;
    if (cart.items && cart.items.length > 0) {
        for (const item of cart.items) {
            const props = item.properties;
            if (props._product_id && props._variant_id) {
                // This is a gift box, check from related product in the cart
                const relatedProduct = cart.items.find(e => e.product_id === props._product_id);
                const isShopper = !!props._gift_box_variant_id;
                if (isShopper) {
                    const relatedGiftBox = cart.items.find(e => e.variant_id === props._gift_box_variant_id);
                    if (!relatedGiftBox) {
                        console.log('Deleting shopper from cart');
                        await updateAt(item.key);
                        console.log('shopper deleted from cart', item);
                    }
                }
                if (!relatedProduct) {
                    // No related product, delete this gift box
                    console.log('Deleting gift box from cart');
                    await updateAt(item.key);
                    console.log('gift box deleted from cart', item);
                } else {
                    // Check the quantities, must be the same
                    if (item.quantity > relatedProduct.quantity) {
                        // adjust cart quantities
                        console.log('Need to adjust quantity', 'Gift box:', item.quantity, 'Related product:', relatedProduct.quantity);
                        await updateAt(item.key, relatedProduct.quantity);
                    }
                }
            }
        }
    }
    if (cart.items_removed && cart.items_removed.length > 0) {
        for (const item of cart.items_removed) {
            console.log('item deleted from cart', item);
        }
    }
    scheduleQuickCartClerkRefresh(cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener('cart:error', function (evt) {
    console.log('Cart error');
    console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener('quick-cart:open', function (evt) {
    console.log('Quick cart opened');
    console.log(evt.detail.cart);
    scheduleQuickCartClerkRefresh(evt.detail && evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener('quick-cart:close', function () {
    console.log('Quick cart closed');
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener('product:variant-change', function (evt) {
    console.log('Product variant changed');
    console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener('product:quantity-update', function (evt) {
    console.log('Product quantity updated');
    console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener('quickview:loaded', function () {
    console.log('Quickview loaded');
});


window.addEventListener('scroll', () => {
    const iub = document.querySelector('.iubenda-cs-preferences-link[data-tp-float]');
    if (!iub) return;
    if(window.scrollY > 250) {
        iub.style.opacity = '0';
    } else {
        iub.style.opacity = '1';
    }
})